import React from "react";
import PropTypes from "prop-types";
import { browserName, browserVersion } from "react-device-detect";
import SweetAlert from "react-bootstrap-sweetalert";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";

//graphql
import gql from "graphql-tag";
import { ApolloClient } from "apollo-client";
import { ApolloProvider } from "react-apollo";
import { HttpLink } from "apollo-link-http";

import { InMemoryCache } from "apollo-cache-inmemory";
import config from "../config";

import history from "../history.js";
// @material-ui/icons
import LockOutline from "@material-ui/icons/Lock";
import People from "@material-ui/icons/People";
// core components
import GridContainer from "../components/Grid/GridContainer.jsx";
import GridItem from "../components/Grid/GridItem.jsx";
import CustomInput from "../custom-components/CustomInput/CustomInput.jsx";
import Card from "../components/Card/Card.jsx";
import CardBody from "../components/Card/CardBody.jsx";
import CardHeader from "../components/Card/CardHeader.jsx";
import CardFooter from "../components/Card/CardFooter.jsx";
import LoaderButton from "../custom-components/LoaderButton";
import Header from "../custom-components/Header/Header.jsx";
import HeaderLinks from "../custom-components/Header/HeaderLinks.jsx";
import image from "../assets/img/bgdark.jpg";
import Footer from "../components/Footer/Footer.jsx";
import axios from "axios";
import loginPageStyle from "../assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";
import date from "date-and-time";

const client = new ApolloClient({
  link: new HttpLink({ uri: config.graphqlendpoint.URL }),
  cache: new InMemoryCache()
});

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: "cardHidden",
      employer_name: "",
      pin: "",
      organization_name: "",
      employer_nameState: "",
      pinState: "",
      organization_nameState: "",
      isLoading: false,
      alert: null,
      path: window.location.href,
      datetime: date
        .addMinutes(new Date(), 330)
        .toJSON()
        .substring(0, 19)
        .replace("T", " "),
      IP: localStorage.getItem("ip"),
      fileContent: null,
    };
  }
  // function that verifies if a string has a given length or not
  verifyLength(value, length) {
    if (value.length >= length) {
      return true;
    }
    return false;
  }
  onloadCallback = () => {};

  // function that verifies if value contains only numbers
  verifyNumber(value, length) {
    var numberRex = new RegExp("^[0-9]+$");
    if (numberRex.test(value) && value.length === length) {
      return true;
    }
    return false;
  }
  autoCloseAlert = (response, fileContent) => {
    localStorage.setItem("userlogged", true);
    this.setState({
      alert: (
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          title="Login Success!"
          onConfirm={() => this.successhideAlert}
          showConfirm={false}
          success
        >
          <h4>Welcome</h4>
        </SweetAlert>
      )
    });
    setTimeout(this.successAlert(response, fileContent), 2000);
  };
  warningWithConfirmMessage = message => {
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Request Failed"
          onConfirm={() => this.failhideAlert}
          showConfirm={false}
        >
          {message}
        </SweetAlert>
      )
    });
    setTimeout(this.failhideAlert, 2000);
  };
  successAlert = (response, fileContent) => {
    this.setState({
      alert: null
    });
    history.push({
      pathname: "/profilepage",
      state: { response, fileContent }
    });
  };

  failhideAlert = () => {
    this.setState({
      alert: null
    });
    // this.props.history.push('/app')
  };

  handleClick = async () => {
    try {
    } catch (e) {}
  };

  change(event, stateName, type, stateNameEqualTo, maxValue) {
    switch (type) {
      case "length":
        if (this.verifyLength(event.target.value, stateNameEqualTo)) {
          this.setState({ [stateName + "State"]: "success" });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "pin":
        if (this.verifyNumber(event.target.value, stateNameEqualTo)) {
          this.setState({ [stateName + "State"]: "success" });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "orgname":
        if (this.verifyLength(event.target.value, stateNameEqualTo)) {
          this.setState({ [stateName + "State"]: "success" });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      default:
        break;
    }
    switch (type) {
      case "checkbox":
        this.setState({ [stateName]: event.target.checked });
        break;
      default:
        this.setState({ [stateName]: event.target.value });
        break;
    }
  }
  enable() {
    if (this.state.pinState === "success") {
      return false;
    } else {
      return true;
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    axios
      .get(" https://api.ipify.org/?format=json")
      .then(res => {
        localStorage.setItem("ip", res.data.ip);
        this.setState({ IP: res.data.ip });
      })
      .catch(err => {});
    setTimeout(
      function() {
        this.setState({ cardAnimaton: "" });
      }.bind(this),
      700
    );
    localStorage.setItem("browserName", browserName);
    localStorage.setItem("browserVersion", browserVersion);
    localStorage.setItem("deviceId", null);
  }
  render() {
    const { classes } = this.props;
    return (
      <div>
        <Header
          color="transparent"
          brand="VERIFY MATE"
          rightLinks={<HeaderLinks />}
          fixed
          changeColorOnScroll={{
            height: 200,
            color: "white"
          }}
          //  {...rest}
        />
        <div
          className={classes.pageHeader}
          style={{
            backgroundImage: "url(" + image + ")",
            backgroundSize: "cover",
            backgroundPosition: "top center"
          }}
        >
          <ApolloProvider client={client}>
            <div className={classes.content}>
              <div className={classes.container}>
                <GridContainer justify="center">
                  <GridItem xs={12} sm={6} md={4}>
                    <form>
                      <Card login className={classes[this.state.cardAnimaton]}>
                        <CardHeader
                          className={`${classes.cardHeader} ${
                            classes.textCenter
                          }`}
                          color="info"
                        >
                          <div>
                            <h4 className={classes.cardTitle}>
                              Document Verification
                            </h4>
                          </div>
                        </CardHeader>

                        <CardBody>
                          <CustomInput
                            success={
                              this.state.employer_nameState === "success"
                            }
                            error={this.state.employer_nameState === "error"}
                            id="name"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              onChange: event =>
                                this.change(
                                  event,
                                  "employer_name",
                                  "length",
                                  3
                                ),
                              type: "length",
                              startAdornment: (
                                <InputAdornment
                                  position="start"
                                  className={classes.inputAdornment}
                                >
                                  <People
                                    className={classes.inputAdornmentIcon}
                                  />
                                </InputAdornment>
                              ),
                              placeholder: "Your Name"
                            }}
                          />
                          <CustomInput
                            success={
                              this.state.organization_nameState === "success"
                            }
                            error={
                              this.state.organization_nameState === "error"
                            }
                            id="orgname"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              onChange: event =>
                                this.change(
                                  event,
                                  "organization_name",
                                  "orgname",
                                  3
                                ),
                              type: "orgname",
                              startAdornment: (
                                <InputAdornment
                                  position="start"
                                  className={classes.inputAdornment}
                                >
                                  <People
                                    className={classes.inputAdornmentIcon}
                                  />
                                </InputAdornment>
                              ),
                              placeholder: "Organization Name"
                            }}
                          />
                          <CustomInput
                            success={this.state.pinState === "success"}
                            error={this.state.pinState === "error"}
                            id="pin"
                            formControlProps={{
                              fullWidth: true
                            }}
                            helpText={
                              this.state.pinState === "error"
                                ? "Please enter valid PIN"
                                : null
                            }
                            inputProps={{
                              type: "pin",
                              onChange: event =>
                                this.change(event, "pin", "pin", 6),
                              startAdornment: (
                                <InputAdornment
                                  position="start"
                                  className={classes.inputAdornment}
                                >
                                  <LockOutline
                                    className={classes.inputAdornmentIcon}
                                  />
                                </InputAdornment>
                              ),
                              placeholder: "PIN*"
                            }}
                          />
                          <div className={classes.formCategory}>
                            <small> *</small> Required fields
                          </div>
                          <br />
                          <GridContainer justify="center">

                          </GridContainer>
                        </CardBody>

                        <CardFooter className={classes.justifyContentCenter}>
                          <LoaderButton
                            isLoading={this.state.isLoading}
                            loadingText="Requesting..."
                            disabled={this.enable()}
                            // type="submit"
                            onClick={async () => {
                              this.setState({ isLoading: true });
                                  await client
                                  .query({
                                    query: fileQuery,
                                    variables: {
                                      pin: parseInt(this.state.pin, 10),
                                      url: this.state.path,
                                      current_time: this.state.datetime,
                                      name: this.state.employer_name,
                                      company_name: this.state
                                        .organization_name,
                                      device_id: localStorage.getItem(
                                        "deviceId"
                                      ),
                                      browser: localStorage.getItem(
                                        "browserName"
                                      ),
                                      ip: this.state.IP
                                    }
                                  })
                                  .then(response => {
                                    if (
                                      response.data.showEmployeeDetails
                                        .profile_image_hash
                                    ) {
                                      // retriving the profile picture
                                      try {
                                        const retrieveProfileData = {
                                          userName:
                                            response.data.showEmployeeDetails
                                              .username,
                                          hasedFilename:
                                            response.data.showEmployeeDetails
                                              .profile_image_hash
                                        };
                                        axios
                                          .post(
                                            config.profileImage.ProfileRetrieve,
                                            retrieveProfileData
                                          )
                                          .then(profileResponse => {
                                            if (profileResponse.data.data) {
                                              this.setState({
                                                fileContent:
                                                  "data:image/jpeg;base64," +
                                                  profileResponse.data.data
                                                    .fileContent,
                                                isLoading: false
                                              });

                                              this.autoCloseAlert(
                                                response,
                                                this.state.fileContent
                                              );
                                            } else {
                                              this.setState({
                                                isLoading: false
                                              });
                                              this.autoCloseAlert(
                                                response,
                                                this.state.fileContent
                                              );
                                            }
                                          })
                                          .catch(err => {
                                            this.setState({ isLoading: false });
                                            this.autoCloseAlert(
                                              response,
                                              this.state.fileContent
                                            );
                                          });
                                      } catch (e) {
                                        this.setState({ isLoading: false });
                                        this.autoCloseAlert(
                                          response,
                                          this.state.fileContent
                                        );
                                      }
                                    } else {
                                      this.setState({ isLoading: false });
                                      this.autoCloseAlert(
                                        response,
                                        this.state.fileContent
                                      );
                                    }
                                  })
                                  .catch(err => {
                                    if (
                                      err.message ===
                                      "GraphQL error: Url Expired"
                                    ) {
                                      this.warningWithConfirmMessage(
                                        "Your URL gets expired"
                                      );
                                    } else {
                                      this.warningWithConfirmMessage(
                                        "Invalid PIN. Please check your PIN."
                                      );
                                    }
                                    this.setState({ isLoading: false });
                                  });
                            }}
                            text="View Documents"
                          />
                        </CardFooter>
                      </Card>
                    </form>
                  </GridItem>
                </GridContainer>
              </div>
              {this.state.alert}
            </div>
          </ApolloProvider>
          <Footer white />
        </div>
      </div>
    );
  }
}

LoginPage.propTypes = {
  classes: PropTypes.object.isRequired
};

const fileQuery = gql`
  query fileQuery(
    $pin: Int!
    $url: String!
    $current_time: String!
    $name: String!
    $company_name: String!
    $device_id: String!
    $browser: String!
    $ip: String!
  ) {
    getFiles(
      pin: $pin
      url: $url
      current_time: $current_time
      name: $name
      company_name: $company_name
      device_id: $device_id
      browser: $browser
      ip: $ip
    ) {
      file_hashes
      exp_time
      document_count
    }
    showEmployeeDetails(url: $url) {
      name
      email
      username
      profile_image_hash
      designation
      department
    }
    showEmployment(url: $url) {
      Employment {
        document_name
        file_id
        file_hash
        document_extension
        document_upload_type
        employee_id
        employer_name
        employer_mail_id
        organization_name
        joining_date
        end_date
        experience
        designation
        department
        verified_status
        __typename
      }
    }
  }
`;

export default withStyles(loginPageStyle)(LoginPage);



// WEBPACK FOOTER //
// ./src/Container/Loginpage.jsx